var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Switch_1;
import React, { PureComponent } from 'react';
import './switch.css';
import { bool, string } from 'prop-types';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, expression } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ChangeEvent, FocusEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, defaultClasses, isFunction } from '@philips-internal/oswald-ui-utils';
import SwitchAPI from './switch-api.js';
let Switch = Switch_1 = class Switch extends PureComponent {
    constructor() {
        super(...arguments);
        this.onBlur = () => {
            const { enabled, onBlur } = this.props;
            const shouldTrigger = enabled && isFunction(onBlur);
            if (shouldTrigger) {
                onBlur(new FocusEvent());
            }
        };
        this.onChange = () => {
            const { enabled, onChange, readOnly, value: oldValue } = this.props;
            const shouldTrigger = enabled && !readOnly && isFunction(onChange);
            const value = !oldValue;
            if (shouldTrigger) {
                onChange(new ChangeEvent({
                    oldValue,
                    prettyValue: this.getLabel(value),
                    value,
                }));
            }
        };
        this.onFocus = () => {
            const { enabled, onFocus } = this.props;
            const shouldTrigger = enabled && isFunction(onFocus);
            if (shouldTrigger) {
                onFocus(new FocusEvent());
            }
        };
    }
    /**
     * Prettifies a given value.
     *
     * @param {object} properties - Properties to generate pretty value.
     * @param {string} properties.offExpression - Expression used when value is true.
     * @param {string} properties.onExpression - Expression used when value is false.
     * @param {boolean} [properties.value] - Dictates the expression to be used.
     * @returns {string} pretty value.
     */
    static formatPrettyValue(props) {
        const { offExpression = Switch_1.defaultProps.offExpression, onExpression = Switch_1.defaultProps.onExpression, value, } = props;
        return MessageService.translate(value ? onExpression : offExpression);
    }
    getClassName() {
        const { className, enabled = Switch_1.defaultProps.enabled, readOnly = Switch_1.defaultProps.readOnly, value, } = this.props;
        const defClasses = defaultClasses({ enabled, readOnly });
        return classNames({
            'c-switch': true,
            'is-active': Boolean(value),
            ...defClasses,
            [`${className}`]: Boolean(className),
        });
    }
    renderSwitch() {
        return (React.createElement("div", { className: "c-switch__track", onBlur: this.onBlur, onClick: this.onChange, onFocus: this.onFocus, "x-contrast": "bg" },
            React.createElement("div", { className: "c-switch__thumb", tabIndex: 0 })));
    }
    getLabel(newValue) {
        const { offExpression = Switch_1.defaultProps.offExpression, onExpression = Switch_1.defaultProps.onExpression, value, } = this.props;
        return Switch_1.formatPrettyValue({ offExpression, onExpression, value: newValue ?? Boolean(value) });
    }
    renderStatus() {
        const { showStatus } = this.props;
        if (!showStatus) {
            return null;
        }
        return (React.createElement("div", { className: "c-switch__status" }, this.getLabel()));
    }
    render() {
        return (React.createElement("div", { className: this.getClassName() },
            this.renderSwitch(),
            this.renderStatus()));
    }
};
Switch.propTypes = {
    className: string,
    enabled: bool,
    offExpression: expression,
    onBlur: eventListener,
    onChange: eventListener,
    onExpression: expression,
    onFocus: eventListener,
    readOnly: bool,
    showStatus: bool,
    value: bool,
};
Switch.defaultProps = {
    enabled: true,
    offExpression: 'tws.switch.off',
    onExpression: 'tws.switch.on',
    readOnly: false,
    showStatus: true,
};
Switch = Switch_1 = __decorate([
    AwesomeComponent({ api: SwitchAPI, type: ComponentType.DATA_ENTRY })
], Switch);
export default Switch;
//# sourceMappingURL=switch.js.map